export default __webpack_public_path__ + "static/media/wallpaper_bg3.70e86b53.png";